export default {
  manual: 'Manuale',
  filters: {
    status: 'Stato',
    event_type: 'Tipo di evento',
  },
  columns: {
    event: 'Evento',
    status: 'Stato',
    attempts: 'Tentativi',
    last_http_status: 'Ultimo stato HTTP',
    created_at: 'Creata',
  },
  statuses: {
    pending: 'In sospeso',
    delivered: 'Consegnato',
    failed: 'Non riuscito',
  },
  buttons: {
    details: 'Dettagli',
    resend: 'Reinvia',
  },
  detail: {
    title: 'Dettagli consegna',
    event: 'Evento',
    attempts: 'Tentativi',
    no_attempts: 'Nessun tentativo ancora.',
    no_response: 'nessuna risposta',
    payload: 'Payload',
  },
  toasts: {
    load_error: 'Impossibile caricare le consegne.',
    resend_error: 'Impossibile reinviare la consegna.',
    resent: 'Consegna accodata per il reinvio.',
  },
};
